import React, { useState } from 'react';
import { Stack, Button, Menu, MenuItem, Typography, Tooltip, Divider } from '@mui/material';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons';

const ActionMenuButton = ({ menuItems, sx, variant = 'contained', color = 'secondary', icon = faEllipsisH }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const menuButtonStyle = {
    height: '36.5px',
    minWidth: 'auto',
    ...(variant === 'outlined' && {
      color: 'rgba(0, 0, 0, 0.60)',
      borderColor: 'rgba(0, 0, 0, 0.30)',
      '&:hover': {
        borderColor: 'text.primary',
        backgroundColor: 'transparent',
      },
    }),
  };
  const iconStyle = {
    minWidth: '20px',
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.54)',
  };

  return (
    menuItems &&
    menuItems.length > 0 && (
      <>
        <Button
          id="menu-button"
          aria-controls={open ? 'positioned-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleMenuClick}
          variant={variant}
          color={color}
          style={menuButtonStyle}
          sx={sx}
          size="small"
        >
          <FontAwesomeIcon icon={icon} />
        </Button>
        <Menu
          id="positioned-menu"
          aria-labelledby="menu-button"
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          onClick={handleMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          slotProps={{
            paper: {
              sx: { minWidth: 180 },
            },
          }}
        >
          {menuItems.flatMap((item, index) => {
            const menuItemContent = (
              <Stack direction="row" spacing={1} alignItems="center">
                {item.icon && <FontAwesomeIcon icon={item.icon} style={iconStyle} />}
                <Typography variant="body1">{item.label}</Typography>
              </Stack>
            );

            const menuItemElement = item.tooltip ? (
              <Tooltip key={`item-${index}`} title={item.tooltip} placement="left" arrow>
                <span>
                  <MenuItem id={item.label} onClick={item.onClick} disabled={item.disabled} {...item.dataAttributes}>
                    {menuItemContent}
                  </MenuItem>
                </span>
              </Tooltip>
            ) : (
              <MenuItem key={`item-${index}`} id={item.label} onClick={item.onClick} disabled={item.disabled} {...item.dataAttributes}>
                {menuItemContent}
              </MenuItem>
            );

            if (item.divider) {
              return [<Divider key={`divider-${index}`} sx={{ my: 0.5 }} />, menuItemElement];
            }
            return [menuItemElement];
          })}
        </Menu>
      </>
    )
  );
};

ActionMenuButton.propTypes = {
  menuItems: PropTypes.arrayOf(PropTypes.object),
  sx: PropTypes.object,
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  color: PropTypes.string,
  icon: PropTypes.object,
};

export default ActionMenuButton;
